















import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Button, Icon, Input } from "ant-design-vue";

export default Vue.extend({
  name: "ChooseType",
  data() {
    return {};
  },
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Input.name]: Input
  },
  props: {},
  computed: {
    ...mapState("KYC", ["applyType"])
  },
  watch: {},
  methods: {
    ...mapActions(["setToken"]),
    kycType(type: number) {
      if (type !== this.applyType) {
        // reset token when apply type changed
        this.setToken(undefined);
      }

      const { params } = this.$route;
      const state = `1${type}`;

      this.$router.push({
        name: "kyc",
        params,
        query: { ...this.$route.query, state }
      });
    }
  },
  mounted() {}
});
